import React from 'react';
import BtnLanguage from '../Components/BtnLanguage';

import translate from "../Translation/i18nProvider/translate";

function Footer() {
    return (
        
            <footer className="footer">
                <BtnLanguage />
                    <p>
                        {translate('footer')}
                    </p>
            </footer>

    )
}

export default Footer
